import { ContactListCoreProps } from "./types"
import React, { useCallback } from "react"
import { SectionList } from "~/ui/primitives"
import ContactListItem from "./components/contact-list-item"
import styled, { useTheme } from "~/ui/styled"

const Letter = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
`

const SectionLetter: React.FC<{ letter?: string }> = ({ letter }) => {
  const theme = useTheme()
  return (
    <Letter
      style={{
        backgroundColor: theme.colors.background,
        color: theme.colors.text,
      }}
    >
      {letter}
    </Letter>
  )
}

const listShellStyle: React.CSSProperties = {
  flex: 1,
  minHeight: 0,
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
}

const sectionListStyle: React.CSSProperties = {
  flex: 1,
  minHeight: 0,
  height: "100%",
  width: "100%",
}

const sectionListContentStyle: React.CSSProperties = {
  width: "100%",
}

export const ContactListCore: React.FC<ContactListCoreProps> = ({
  sections,
  swipeActionButtonConfigs,
  onItemClick,
  selecteds,
}) => {
  const keyExtractor = useCallback((item) => item.id.toString(), [])
  const renderItem = useCallback(
    ({ item, index, section }) => {
      const isLastItem = index === section.data.length - 1
      return (
        <ContactListItem
          contact={item}
          swipeActionButtonConfigs={swipeActionButtonConfigs}
          onItemClick={onItemClick}
          selecteds={selecteds}
          isLastItem={isLastItem}
        />
      )
    },
    [selecteds, onItemClick, swipeActionButtonConfigs],
  )
  const renderSectionHeader = useCallback(
    ({ section }: { section: { letter?: string } }) => (
      <SectionLetter letter={section.letter} />
    ),
    [],
  )

  return (
    <div style={listShellStyle}>
      <SectionList
        style={sectionListStyle}
        contentContainerStyle={sectionListContentStyle}
        showsVerticalScrollIndicator={false}
        sections={sections}
        keyExtractor={keyExtractor}
        renderSectionHeader={renderSectionHeader}
        renderItem={renderItem}
      />
    </div>
  )
}
